import { Colors } from 'mgUiKit';
import { set, get } from './Storage';
// import cookie from 'react-cookie';
import { UserSettings } from './UserSettings';

function init() {
    const { GetSettings } = require('mgToolsKit');
    var AppSettings = GetSettings('UserBox');

    var _version = "3.0.1";
    AppSettings["version"] = _version;

    if (process.env.NODE_ENV != "production") {
        console.log("[" + process.env.NODE_ENV + " environment] Starting UserBox version " + _version + " ....done");
    }

    if (AppSettings.device == undefined || AppSettings.device == "") {
        AppSettings.device = "desktop";
    }
    
    if(AppSettings.sportsbookenabled == undefined || AppSettings.sportsbookenabled == ""){
        AppSettings.sportsbookenabled = true;
    }
    
    if(AppSettings.theme == undefined)
        AppSettings.theme = {};

    if (AppSettings.theme.primarycolor == undefined || AppSettings.theme.primarycolor == "") {
        AppSettings.theme.primarycolor = Colors.blue500;
    }    

    if (AppSettings.theme.secondarycolor == undefined || AppSettings.theme.secondarycolor == "") {
        AppSettings.theme.secondarycolor = Colors.blue500;
    }

    if (AppSettings.theme.version == undefined || AppSettings.theme.version == "") {
        AppSettings.theme.version = "light";
    }

    if(AppSettings.theme.switchthemeversionenabled == undefined || AppSettings.theme.switchthemeversionenabled == ""){
        AppSettings.theme.switchthemeversionenabled = false;
    }
    else{
        AppSettings.theme.switchthemeversionenabled = AppSettings.theme.switchthemeversionenabled == "true";
    }

    if (AppSettings.usersettings == undefined || AppSettings.usersettings == "") {
        AppSettings.usersettings = false;
    } else {
        AppSettings.usersettings = AppSettings.usersettings == "true";
    }

    if (AppSettings.sportsbookenabled == undefined || AppSettings.sportsbookenabled == "") {
        AppSettings.sportsbookenabled = true;
    } else {
        AppSettings.sportsbookenabled = AppSettings.sportsbookenabled == "true";
    }

    if (AppSettings.isauthenticated == undefined || AppSettings.isauthenticated == "") {
        AppSettings.isauthenticated = false;
    } else {
        AppSettings.isauthenticated = AppSettings.isauthenticated == "true";
    }
    //AppSettings.disableautorenew = AppSettings.disableautorenew == 'true';
    //AppSettings.enablekeepalive = AppSettings.enablekeepalive == 'true';

    AppSettings.disableautorenew = false;
    AppSettings.enablekeepalive = false;

    if (AppSettings.showdepositbuttonintoolbar == undefined || AppSettings.showdepositbuttonintoolbar == "") {
        AppSettings.showdepositbuttonintoolbar = false;
    } else {
        AppSettings.showdepositbuttonintoolbar = AppSettings.showdepositbuttonintoolbar == "true";
    }

    if (AppSettings.mostrabtnpreleva == undefined || AppSettings.mostrabtnpreleva == "") {
        AppSettings.mostrabtnpreleva = false;
    } else {
        AppSettings.mostrabtnpreleva = AppSettings.mostrabtnpreleva == "true";
    }

    // Init ToolbarMode
    /*
    if (AppSettings.device == "mobile") {
        AppSettings.toolbarMode = "compact";
    }*/

    if(AppSettings.forcetoolbartype == undefined){
        AppSettings.forceTtoolbartype = "";
    }

    if (AppSettings.couponurl == undefined) {
        AppSettings.couponurl = {
            casino: "",
            casinolive: "",
            poker: "",
            bingo: "",
            cardgames:"",
        };
    }

    if(AppSettings.funbonusurl == undefined){        
        AppSettings.funbonusurl = "";
    }

    if(AppSettings.openlinkpopup == undefined){
        AppSettings.openlinkpopup = false;
    }
    else{
        AppSettings.openlinkpopup = AppSettings.openlinkpopup == "true";
    }

    if(AppSettings.globalswitchthemeenabled == undefined){
        AppSettings.globalswitchthemeenabled = false;
    }
    else{
        AppSettings.globalswitchthemeenabled = AppSettings.globalswitchthemeenabled == "true";
    }    

    if(AppSettings.badgemasteragent == undefined){
        AppSettings.badgemasteragent = false;
    }
    else{
        AppSettings.badgemasteragent = AppSettings.badgemasteragent === "true";
    }
    
    AppSettings['label'] = _userboxLabel;
    set(AppSettings);
    var Styles = require('./Styles').default;
    var Env = require('./Env').default;

    AppSettings["env"] = Env[process.env.NODE_ENV];
    AppSettings["styles"] = Styles;

    AppSettings["env"].localStorageToggleBalance = "toolbarBalanceMode" + AppSettings.device;
    AppSettings['balanceOpened'] = false;
    if (typeof (Storage) !== "undefined") {
        var toggleBalance  = localStorage.getItem(AppSettings["env"].localStorageToggleBalance);
        if(toggleBalance == undefined){
            toggleBalance = false;
            localStorage.setItem(AppSettings["env"].localStorageToggleBalance, toggleBalance);
        }
        else{
            toggleBalance = toggleBalance == "true";
        }
        AppSettings['balanceOpened'] = toggleBalance;
    }


    /*
    AppSettings["env"].cookieNameToolbarMode = "toolbarMode" + AppSettings.device;
    if (cookie.load(AppSettings["env"].cookieNameToolbarMode) == undefined) {
        var toolbarMode = AppSettings.toolbarMode == undefined ? 'full' : AppSettings.toolbarMode;
        cookie.save(AppSettings["env"].cookieNameToolbarMode, toolbarMode, { path: '/' });
    }
    */

    AppSettings['appId'] = "UserBox";
    AppSettings['userSettings'] = UserSettings;
    set(AppSettings);
}
export default init();